var React = require('react');

function Repeat (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M22.885,0.798c-8.45,0-15.708,5.181-18.91,12.567l-2.131-0.854c-0.505-0.203-1.082-0.081-1.461,0.308c-0.38,0.39-0.489,0.969-0.275,1.468l3.39,7.922c0.141,0.327,0.404,0.587,0.736,0.719c0.331,0.134,0.701,0.13,1.028-0.012l7.922-3.39c0.499-0.213,0.82-0.707,0.814-1.251c-0.007-0.543-0.34-1.029-0.844-1.231l-2.686-1.076c2.162-4.813,6.905-8.17,12.416-8.17c7.542,0,13.678,6.272,13.678,13.983c0,7.711-6.138,13.984-13.678,13.984c-3.349,0-6.413-1.24-8.789-3.294c-1.387-1.198-3.452-1.141-4.743,0.161c-0.017,0.018-0.033,0.033-0.05,0.051c-1.423,1.432-1.32,3.766,0.207,5.084c3.607,3.114,8.277,4.998,13.375,4.998c11.401,0,20.678-9.412,20.678-20.984C43.564,10.211,34.287,0.798,22.885,0.798z"})));
}

Repeat.defaultProps = {"className":"repeat-icon","version":"1.1","fill":"#fff","height":"48px","width":"43.562px","viewBox":"0 0 43.562 43.562"};

module.exports = Repeat;

Repeat.default = Repeat;
